import React from 'react';

import { ChapterWrapper } from '~/ChapterWrapper';
import Footer from '~/Footer';
import { Path } from '~/paths';

export const ExSetsMeta = {
    title: "Cvičení: Množiny",
    shortTitle: "Množiny",
    path: Path.ex_sets,
    element: (sectionNumber:string) => <ExSets sectionNumber={sectionNumber}/>,
    sectionNumber: "",
}

export function ExSets({sectionNumber}: {sectionNumber: string}) {

    return (
        <ChapterWrapper sectionNumber={sectionNumber} title={ExSetsMeta.title}>

            <p>
            <i>Připravujeme...</i>
            </p>

            <Footer/>
        </ChapterWrapper>
    );
}

